import { UserKeys } from '@webapp/platform/iam/entities/enums/UserKeys'

const userKey = 'user'

export const userKeys = {
  list: [userKey, UserKeys.LIST],
  details: [userKey, UserKeys.DETAIL],
  purchasePriceLimit: [userKey, UserKeys.PURCHASE_PRICE_LIMIT],
  getCounts: [userKey, UserKeys.COUNTS],
}
